export class categories {
    id: number;
    name: string;
    image: any;
    hide:any
    parent_id: string;
  }